import { useEffect, useState } from "react";
import ConfirmModal from "components/ui/ConfirmModal";
import CommonModal from "components/ui/CommonModal";
import { subscribeAppOnly, hideAppOnly } from "util/appOnlyPrompt";
import { storeUrlForOS, openStore } from "constants/appStore";

/**
 * 앱 전용 기능 안내 모달 — App 루트에 1회 마운트(AppToastHost 관례).
 *  웹에서 네이티브 전용 화면을 열려고 하면 안내 + 설치 유도.
 *  스토어 URL 이 없으면(미출시/데스크톱) 설치 버튼 없이 안내만 보여준다.
 */
export default function AppOnlyModalHost() {
  const [state, setState] = useState(null);
  useEffect(() => subscribeAppOnly(setState), []);

  const open = !!state;
  const canInstall = !!storeUrlForOS();

  if (canInstall) {
    return (
      <ConfirmModal
        isShow={open}
        title="앱에서 이용할 수 있어요"
        body={state?.message || ""}
        cancelText="닫기"
        confirmText="앱 설치하기"
        onCancel={hideAppOnly}
        onConfirm={() => {
          openStore();
          hideAppOnly();
        }}
      />
    );
  }

  return (
    <CommonModal
      isShow={open}
      closeModal={hideAppOnly}
      content={{ title: "앱에서 이용할 수 있어요", body: state?.message || "" }}
    />
  );
}
